import { Radio } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const OverviewWrapper = styled.div``;

const RedemptionWindowWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;

  ${Radio.S.InputLabel} {
    white-space: nowrap;
  }
`;

export { OverviewWrapper, RedemptionWindowWrapper };
